import React from 'react';

import { DivStyled, DivGlobalStyled } from './ColoredBlock.style';

interface Props {
  icon: string;
  text: string | JSX.Element | JSX.Element[];
}

export const ColoredBlock: React.FunctionComponent<Props> = ({ icon, text }: Props) => {
  return <DivGlobalStyled>
    <img src={icon} alt=""/>
    <DivStyled>
      {text}
    </DivStyled>
  </DivGlobalStyled>;
};
